import { patientApi } from '@/api/PatientApi'
import type { PatientInfo } from '@/api/types/PatientApi'
import { useQuery } from '@tanstack/react-query'

const useFetchPatientInfo = () => {
	const { data = {} as PatientInfo } = useQuery({
		queryKey: ['patient-info'],
		queryFn: () => patientApi.getPatientInfo(),
		staleTime: 30000,
	})

	return {
		patientInfo: data,
	}
}

export { useFetchPatientInfo }
